module.exports = __webpack_public_path__ + "img/ActiveroundTickPlus_1.87186a4a.svg";